import { NgIf } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { ClientControlService, ControlNotice } from '../../../services/client-control.service';

@Component({
  selector: 'vex-client-notice-banner',
  standalone: true,
  imports: [NgIf],
  templateUrl: './client-notice-banner.component.html',
  styleUrl: './client-notice-banner.component.scss'
})
export class ClientNoticeBannerComponent implements OnInit, OnDestroy {
  notice: ControlNotice | null = null;
  clientName = '';
  leaving = false;
  private subscription?: Subscription;
  private exitTimer?: ReturnType<typeof setTimeout>;

  constructor(private clientControl: ClientControlService) {}

  ngOnInit(): void {
    this.subscription = this.clientControl.policy$.subscribe(policy => {
      this.clientName = policy.clientName || '';
      if (policy.notice) {
        clearTimeout(this.exitTimer);
        this.notice = policy.notice;
        this.leaving = false;
      } else if (this.notice && !this.leaving) {
        this.leaving = true;
        this.exitTimer = setTimeout(() => { this.notice = null; this.leaving = false; }, 280);
      }
    });
  }

  dismiss(): void {
    if (this.notice && !this.notice.blockWork) this.clientControl.dismiss(this.notice);
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
    clearTimeout(this.exitTimer);
  }
}
